import React from "react";
import { Box } from "@mui/material";

const ImageMessage = ({ link }) => {

  const handleClick = () => {
      window.open(link, "_blank");
    }

  return (
      <Box
        component="img"
        src={link}
        alt="Agent image"
        className="image-message"
        onClick={handleClick}
      />
  );
};

export default ImageMessage;
